const PA_TERMS = I18n.t('program_applications.form.terms');

const termsCheckbox = (data) => {
  let text = PA_TERMS;
  const {customTermsText} = data;

  if (customTermsText && String(customTermsText).trim().length > 0) {
    text = customTermsText;
  }

  return {
    type: 'checkbox',
    name: 'pa-terms',
    titleLocation: 'hidden',
    required: true,
    choices: [{value: '1', text: text}],
    errorLocation: 'bottom',
    validators: [
      {
        type: 'expression',
        text: 'Response required.',
        expression: '{pa-terms} notempty',
      }
    ]
  }
};

const profilePageElement = (showEmailTooltip) => {
  return {
    name: 'page_profile',
    elements: [
      {
        type: 'user-profile',
        name: 'user-profile',
        titleLocation: 'hidden',
        showExtendedProfile: true,
        disabledFields: ['email'],
        isProgramApplicationForm: true,
        showEmailTooltip: showEmailTooltip,
      }
    ]
  }
};

export function addProgramApplicationElements(data, showEmailTooltip, isNewUser) {
  data.pages[data.pages.length - 1]['elements'].push(termsCheckbox(data));

  // In admin area, only add checkbox - skip everything else
  if (location.pathname.startsWith('/nv/admin/forms') ||
      location.pathname.startsWith('/nv/admin/programs')) {
    return;
  }

  const {pagePrevText, pageNextText, completeText} = {...data};

  data.pagePrevText = I18n.t('program_applications.form.previous_page');
  data.pageNextText = I18n.t('program_applications.form.save_and_continue');
  data.completeText = I18n.t('program_applications.form.submit');

  if (typeof window.I18n !== 'undefined') {
    let locale = window.I18n.locale.toLowerCase();
    if (locale === 'en') {
      locale = 'default';
    }
    const localizedFields = {
      pagePrevText,
      pageNextText,
      completeText
    };

    Object.entries(localizedFields).forEach(([key, translations]) => {
      const value = translations?.[locale]?.trim();
      if (value) {
        data[key] = value;
      }
    });
  }

  if (isNewUser) {
    return;
  }

  data.pages.unshift(profilePageElement(showEmailTooltip));
}

export function addProgramApplicationFormProgressBar(model) {
  model.addNavigationItem({
    id: 'sv-nav-current-progress',
    component: 'sv-pa-form-steps',
    data: {
      model,
    },
    visibleIndex: 25,
    active: false,
    css: 'nav-button',
    innerCss: 'sd-btn nav-input',
  });
}
